import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Estudiantes asignados", -1)
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Estudiantes divididos por tutor", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseStudents = _resolveComponent("CourseStudents")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_Unassigned = _resolveComponent("Unassigned")!
  const _component_Groups = _resolveComponent("Groups")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_ctx.isNotStarted)
    ? (_openBlock(), _createBlock(_component_TabView, {
        key: 0,
        id: "tabNav",
        class: "center-spaceBetween-tabview"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, { header: "Asignados" }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_CourseStudents, {
                students: _ctx.studentsByTutor,
                loadingStudents: _ctx.loadingStudents,
                challengeStats: _ctx.challengeStats,
                courseId: _ctx.courseId,
                tutors: _ctx.tutors
              }, null, 8, ["students", "loadingStudents", "challengeStats", "courseId", "tutors"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, { header: "Sin asignar" }, {
            default: _withCtx(() => [
              _createVNode(_component_Unassigned, {
                students: _ctx.studentsByTutor,
                loadingStudents: _ctx.loadingStudents,
                courseId: _ctx.courseId,
                tutors: _ctx.tutors,
                tutoring: _ctx.tutoring,
                onReloadStudents: _ctx.getStudents
              }, null, 8, ["students", "loadingStudents", "courseId", "tutors", "tutoring", "onReloadStudents"])
            ]),
            _: 1
          }),
          true
            ? (_openBlock(), _createBlock(_component_TabPanel, {
                key: 0,
                header: "Grupos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Groups, {
                    courseId: _ctx.courseId,
                    tutors: _ctx.tutors,
                    tutorsGroup: _ctx.tutorsGroup,
                    loadingStudents: _ctx.loadingStudents,
                    students: _ctx.studentsByTutor,
                    tutoring: _ctx.tutoring,
                    tutoringGroup: _ctx.tutoringGroup,
                    teachersPowerBi: _ctx.teachersPowerBi,
                    courseNumber: _ctx.courseNumber,
                    onReloadStudents: _ctx.getStudents
                  }, null, 8, ["courseId", "tutors", "tutorsGroup", "loadingStudents", "students", "tutoring", "tutoringGroup", "teachersPowerBi", "courseNumber", "onReloadStudents"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_CourseStudents, {
          students: _ctx.studentsByTutor,
          loadingStudents: _ctx.loadingStudents,
          challengeStats: _ctx.challengeStats,
          courseId: _ctx.courseId,
          tutors: _ctx.tutors,
          courseNumber: _ctx.courseNumber
        }, null, 8, ["students", "loadingStudents", "challengeStats", "courseId", "tutors", "courseNumber"])
      ]))
}